export default __webpack_public_path__ + "5d45ce57fb2e7e25b73c5360a43f6f71.png";